import {getCurrentInstance} from 'vue'

/**
 * Generates a unique form ID for validation forms
 * Uses Vue component instance UID to ensure uniqueness
 * 
 * @param prefix - Prefix for the form ID (e.g., 'rfq', 'hydraulicSelector', 'oring')
 * @returns Unique form ID string
 * 
 * @example
 * const formId = generateFormId('rfqValidationForm')
 * // Returns: 'rfqValidationFormId_123' (where 123 is component UID)
 */
export const generateFormId = (prefix: string): string => {
  const instance = getCurrentInstance()
  const uid = (instance as any)?.uid || Math.random().toString(36).substring(2, 11)
  return `${prefix}Id_${uid}`
}
